<template>
  <div class="py-2 px-0 text-xs">
    <el-button
      id="collapse-button"
      size="mini"
      icon="el-icon-s-unfold"
      style="height: 40px;"
      class="mb-2"
      @click="setSidebarOpen(true)"
      v-if="!sidebarOpen"
      >Display Explorer</el-button
    >
    <div
      class="w-full flex flex-col lg:flex-row space-x-0 space-y-2 lg:space-x-2 lg:space-y-0"
    >
      <div
        class="w-full lg:w-1/3"
        :class="!sidebarOpen ? 'hidden' : ''"
        v-loading="loading"
      >
        <Sidebar
          :loading="loading"
          :data-tree="deviceData"
          :customer="customer"
          :form="form"
          @reset="reset"
          @deviceGroupSelected="deviceGroupSelected"
          @fetchCustomerDevice="fetchDevice"
          @showSidebar="setSidebarOpen"
        />
      </div>
      <div
        class="pr-0 lg:pr-4"
        :class="!sidebarOpen ? 'w-full' : 'lg:w-2/3 w-full'"
      >
        <Content
          :content="content"
          :loading="loading"
          :sensor-data="sensorData"
          :form="form"
          @sensorsSelected="sensorsSelected"
          @nextPage="nextPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/formula/InitSidebar'
import Content from '@/components/formula/InitContent'
export default {
  components: {
    Sidebar,
    Content
  },
  data() {
    return {
      customer: [],
      deviceData: [],
      sensorData: [],
      deviceDceIds: [],
      form: {
        deviceDceIds: [],
        customerSensorIds: [],
        customerId: ''
      },
      content: true,
      loading: false,
      sidebarOpen: true
    }
  },
  mounted() {
    this.getCustomer()

    // set filter data from query parameter
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'customerId')) {
      for (var prop in this.$route.query) {
        this.form[prop] = this.$route.query[prop]
      }

      // submit data
      if (this.form.deviceDceIds) {
        this.submit(this.form.deviceDceIds)
      }
    }
  },
  methods: {
    setFormData(val) {
      this.form = val
    },
    nextPage(customerSensorIds) {
      // move to others page
      this.$router.push({
        name: 'formula-config',
        query: {
          deviceDceIds: this.form.deviceDceIds,
          customerSensorIds: this.form.customerSensorIds,
          customerId: this.form.customerId
        }
      })
    },
    sensorsSelected(customerSensorIds) {
      // push parameters to url
      this.pushParameters({
        customerSensorIds: customerSensorIds
      })

      this.form.customerSensorIds = customerSensorIds
    },
    deviceGroupSelected(value, data) {
      let lastnode = []
      data.checkedNodes.forEach(function (item) {
        if (item.children.length == 0 || item.children === null) {
          //last node
          lastnode.push(item.Dce_id)
        }
      })

      // push parameters to url
      this.pushParameters({
        deviceDceIds: lastnode,
        customerId: this.form.customerId
      })

      this.form.deviceDceIds = lastnode
      this.submit(this.form.deviceDceIds)
    },
    setSidebarOpen(val) {
      this.sidebarOpen = val
    },
    pushParameters(newObject) {
      // push parameter
      this.$router.push({
        query: Object.assign({}, this.$route.query, newObject)
      })
    },

    async submit(DeviceDceId) {
      try {
        this.loading = true

        if (DeviceDceId.length > 0) {
          const res = await this.$axios.post(
            this.$appInfo.api.treeGroupDevice.getListSensorByDevicePost,
            {
              DeviceDceId: DeviceDceId
            }
          )
          this.sensorData = res.data.map(function (item) {
            item.Id = item.DceSensorId
            return item
          })
        } else {
          this.sensorData = []
        }
        this.loading = false
        // console.log(res.data.SensorName)
      } catch (err) {
        this.loading = false
        console.log(err)
      }
    },
    async getCustomer() {
      try {
        this.loading = true
        const res = await this.$axios.get(this.$appInfo.api.customer.getAll)
        this.customer = res.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async fetchDevice(CustomerDcoId) {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.treeGroupDevice.getCustTreeDeviceLevel +
            `?CustomerDcoId=${CustomerDcoId}`
        )
        this.deviceData = res.data
        this.form.customerId = CustomerDcoId
        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    async reset() {
      this.customer = []
      this.deviceData = []
      this.sensorData = []
      await this.getCustomer()
    }
  },
  computed: {
    isCustomer() {
      return this.$store.state.auth.isCustomer
    },
    user() {
      return this.$store.state.auth.userData
    }
  }
}
</script>
